import api from "./api";

/**
 * Normalize one backend item to { sku } or null.
 */
function normalizeSkuItem(x) {
  if (typeof x === "string") return { sku: x.trim() };
  if (!x || typeof x !== "object") return null;
  const sku = x.sku ?? x.SKU ?? x.sku_code ?? x.product_sku;
  return sku != null && String(sku).trim() !== "" ? { sku: String(sku).trim() } : null;
}

/**
 * Fetch SKUs for a batch from the backend (no dummy fallback).
 * GET /api/batches/:batchId/skus
 *
 * @param {number|string} batchId
 * @returns {Promise<{companyName: string, batchId: number|string, items: Array<{sku: string}>}>}
 */
export async function getBatchSkus(batchId) {
  const companyId = localStorage.getItem("company_id");

  const res = await api.get(
    `/api/batches/${encodeURIComponent(
      String(batchId)
    )}/skus?company_id=${companyId}`
  );
  const payload = res?.data;

  // Accept multiple possible response shapes:
  // 1) { success: true, companyName, items:[{sku}] }
  // 2) { success: true, data: { companyName, items:[{sku}] } }
  // 3) { companyName, items:[{sku}] }
  const normalized =
    payload?.data && typeof payload?.data === "object" ? payload.data : payload;

  if (normalized && typeof normalized === "object" && normalized.success === false) {
    throw new Error(normalized.message || "Batch SKUs request failed");
  }

  const companyName =
    normalized?.companyName ||
    normalized?.company_name ||
    normalized?.company ||
    "Company";

  const itemsRaw =
    normalized?.items || normalized?.skus || normalized?.data || [];
  const items = Array.isArray(itemsRaw)
    ? itemsRaw.map(normalizeSkuItem).filter(Boolean)
    : [];

  if (!items.length) {
    throw new Error("No SKUs returned for this batch");
  }

  return { companyName, batchId, items };
}
